define('v3/Common/Components/Survey/Services/surveyService',[
	'moment',
	'v3/Common/Services/Backend/surveyBackend'
], function (moment, surveyBackend) {
	return {
		getStartOfBusinessDayTime: function () {
			var result = new Date();
			result.setHours(7, 30, 0);

			return result;
		},

		getEndOfBusinessDayTime: function () {
			var result = new Date();
			result.setHours(15, 0, 0);

			return result;
		},

		isSurveyClosable: function (time) {
			var day = moment(time).day();
			if (day === 0 || day === 6) {
				return false;
			}

			return time >= this.getStartOfBusinessDayTime() &&
				time <= this.getEndOfBusinessDayTime();
		},

		getActiveSurvey: function () {
			return surveyBackend.getSurvey();
		},

		answerQuestion: function (questionId, answer, answerOption, completeSurvey) {
			return surveyBackend.answerQuestion(questionId, answer, answerOption, completeSurvey);
		}
	};
});
